import {
  Paper,
  Title,
  Button,
  Stack,
  Image,
  Center,
  rem,
} from '@mantine/core';
import classes from './Login.module.css';
import wallpaper from '../../content/Images/amx-max-2.jpg';
import { useAuth0 } from '@auth0/auth0-react'

function Login() {  
  const { loginWithRedirect } = useAuth0();
  const { isAuthenticated, user } = useAuth0();

  console.log(isAuthenticated, user);

  return (
    <div className={classes.loginTopImageLayout}>
      <Center>
        <Paper
          radius="md"
          p="xl"
          withBorder
          shadow="md"
          style={{
            width: rem(560),
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Title order={2} className={classes.title} align="center" mb="md">
            SSCN
          </Title>
          <Image
            src={wallpaper}
            alt="Login Banner"
            height={250}
            fit="cover"
            radius="md"
            style={{
              width: '100%',
              objectPosition: 'center',
              marginBottom: '1rem',
            }}
          />

          <Stack style={{ width: '100%' }}>
            <Button fullWidth mt="xl" size="md" className={classes.amprimary} onClick={() => { loginWithRedirect() }} >
              Login with gateone
            </Button>
          </Stack>
        </Paper>
      </Center>
    </div>
  );
}

export default Login;